import axios from '../../../axios';

const url = 'invoicingservice/api/client-our-entity';

export const getClientOurEntity = (clientId: string) => axios.post(`${url}/${clientId}/list`);
export const saveClientOurEntity = (payload: string[], clientId: string) =>
  axios.post(`${url}/${clientId}/save`, payload);
export const getClientOurEntityDetail = (clientId: string) =>
  axios.post(`${url}/${clientId}/detail-list`);
export const unAssignOurEntity = (payload: string[], clientId: string) =>
  axios.post(`${url}/${clientId}/un-assign`, payload);
export const assignOurEntity = (payload: string[], clientId: string) =>
  axios.post(`${url}/${clientId}/assign`, payload);
